import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to determine if order quantity on Calendar page
 * should be taken from order.totalQuantity value (false) or
 * calculated as a sum of order products quantities (true)
 */
@Injectable()
export class CountOrderQuantityFromProductsFeature implements IFlagFeature {
  name: string = Features.COUNT_ORDER_QUANTITY_FROM_PRODUCTS;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
